module.exports = __webpack_public_path__ + "static/media/background.7147fc0c.jpg";